import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export default class HideOnScroll {
  constructor(element) {
    this.element = element;

    // tolerance: after scrolling how many pixels should scrolltrigger trigger?
    this.tolerance = element.dataset.tolerance;

    // breakpoint to trigger effect
    this.breakpoint = element.dataset.breakpoint;

    this.init();
  }

  init() {
    const mm = gsap.matchMedia();

    mm.add(this.breakpoint, () => {
      ScrollTrigger.observe({
        target: window,
        type: 'scroll',
        tolerance: this.tolerance,
        onUp: () => this.element.classList.remove('hide-on-scroll'),
        onDown: () => this.element.classList.add('hide-on-scroll'),
      });

      return () => {
        this.element.classList.remove('hide-on-scroll');
      };
    });

    //
  }
}
